import { render, staticRenderFns } from "./EditContentMove.vue?vue&type=template&id=6c0620f7&"
import script from "./EditContentMove.vue?vue&type=script&lang=js&"
export * from "./EditContentMove.vue?vue&type=script&lang=js&"
import style0 from "./EditContentMove.vue?vue&type=style&index=0&id=6c0620f7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports